var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-card',_vm._b({staticClass:"c-content-product-card"},'content-card',{
    ..._vm.$props,
    imageHeight: '300px',
    imageWidth: '300px',
    cta: _vm.productCta,
    description: _vm.productPrice,
    image: _vm.productImage,
    newBadge: _vm.productNewBadge,
    title: _vm.productTitle,
    titleTypography: 't-heading-6'
  },false),[(_vm.product && _vm.productAddToCartEnabled)?[_c('product-info-size',{attrs:{"product":_vm.product,"size":_vm.size,"is-gift-card":_vm.isGiftCard},on:{"update:size":function($event){_vm.size=$event}}}),_vm._v(" "),_c('btn',{staticClass:"c-content-product-card__add-to-cart-button",attrs:{"disabled":!_vm.size,"is-disabled":!_vm.size},on:{"click":_vm.addToCart}},[(_vm.size)?_c('span',[(_vm.justAddedToCart)?_c('span',[_vm._v(" Add another? ")]):_c('span',[_vm._v(" Add to Cart ")])]):_c('span',[_vm._v(" Select Size ")])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }